import * as React from 'react';
import {
  Collapse,
  Container,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from 'reactstrap';
import { Outlet, useNavigate } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { observer } from 'mobx-react-lite';

const QsightNavbar = () => {
  const navigate = useNavigate();

  return (
    <>
      <header>
        <Navbar className='navbar-expand-lg navbar-dark qsight-top-header' dark>
          <Container>
            <NavbarBrand></NavbarBrand>

            <UncontrolledDropdown>
              <DropdownToggle tag='span' className='hospital-picker d-none d-md-block'>
                <span
                  id='departmentname'
                  className='hospital-picker'
                  title='General Hospital - Interventional Radiology'
                >
                  General Hospital - Interventional Radiology
                </span>
                <Icon.GeoAltFill className='float-right' />
              </DropdownToggle>
              <DropdownMenu className='wide'>
                <div className='title'>Select Hospital - Department</div>
                <div className='content'>
                  <ul>
                    <li>
                      <select className='form-control custom-select'>
                        <option value='217187'>General Hospital - Interventional Radiology</option>
                        <option value='222059'>
                          Geisinger Community Medical Center TEST - Catheterization Lab
                        </option>
                        <option value='222058'>
                          Geisinger Community Medical Center TEST - Electrophysiology
                        </option>
                        <option value='222057'>
                          Geisinger Community Medical Center TEST - Interventional Radiology
                        </option>
                        <option value='222063'>
                          General Hospital - Pacific West - Operating Room
                        </option>
                        <option value='220326'>General Hospital 02 - Wound Closure</option>
                        <option value='222062'>
                          Univ of Utah Hospital TEST - Farmington Health Ctr - Endoscopy
                        </option>
                        <option value='222061'>
                          University of Virginia Health System TEST - Catheterization Lab
                        </option>
                        <option value='222060'>
                          University of Virginia Health System TEST - Endoscopy Outpatient Center
                        </option>
                      </select>
                    </li>
                  </ul>
                </div>
                <div className='footer text-white bg-dark'>
                  <Icon.ExclamationTriangleFill /> Switching departments will redirect you back to
                  your starting page
                </div>
              </DropdownMenu>
            </UncontrolledDropdown>

            <ul className='nav navbar-nav float-lg-right qsight-user-nav d-none d-md-block ml-auto'>
              <li className='nav-item float-lg-right icon-bar'>
                <UncontrolledDropdown>
                  <DropdownToggle tag='span'>
                    <Icon.PersonCircle className='mr-1' />
                    <span style={{ verticalAlign: 'middle', fontSize: '1rem' }}>Erik Runia</span>
                    <Icon.ChevronCompactDown />
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem tag='span' className='mt-2'>
                      <Icon.Building className='mr-2' />
                      General Hospital
                    </DropdownItem>
                    <DropdownItem tag='span' className='mt-2'>
                      <Icon.Sliders className='mr-2' />
                      My Account
                    </DropdownItem>
                    <DropdownItem tag='span' className='mb-2'>
                      <Icon.Power className='mr-2' />
                      <span>Log Out</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </li>

              <li className='nav-item float-lg-right icon-bar'>
                <Icon.Gear />
              </li>

              <li className='nav-item float-lg-right icon-bar'>
                <Icon.ChatDots />
              </li>

              <li className='nav-item dropdown float-lg-right icon-bar'>
                <Icon.QuestionCircle />
              </li>
            </ul>
            <ul className='nav navbar-nav float-lg-right qsight-user-nav d-block d-sm-none'>
              <li className='dropdown nav-item'>
                <NavbarToggler>
                  <Icon.List />
                </NavbarToggler>
              </li>
            </ul>
          </Container>
        </Navbar>
        <Navbar className='navbar-expand-lg qsight-sub-header' light>
          <Container>
            <Navbar className='navbar-expand-md'>
              <span className='icon-bar d-block d-sm-none'>
                <UncontrolledDropdown>
                  <DropdownToggle tag='button' size='sm' className='btn-hospital-picker'>
                    <span
                      id='departmentname'
                      className='hospital-picker'
                      title='General Hospital - Interventional Radiology'
                    >
                      General Hospital - Interventional Radiology
                    </span>
                    <Icon.GeoAltFill className='float-right mt-1' />
                  </DropdownToggle>
                  <DropdownMenu className='wide'>
                    <div className='title'>Select Hospital - Department</div>
                    <div className='content'>
                      <ul>
                        <li>
                          <select className='form-control custom-select'>
                            <option value='217187'>
                              General Hospital - Interventional Radiology
                            </option>
                            <option value='222059'>
                              Geisinger Community Medical Center TEST - Catheterization Lab
                            </option>
                            <option value='222058'>
                              Geisinger Community Medical Center TEST - Electrophysiology
                            </option>
                            <option value='222057'>
                              Geisinger Community Medical Center TEST - Interventional Radiology
                            </option>
                            <option value='222063'>
                              General Hospital - Pacific West - Operating Room
                            </option>
                            <option value='220326'>General Hospital 02 - Wound Closure</option>
                            <option value='222062'>
                              Univ of Utah Hospital TEST - Farmington Health Ctr - Endoscopy
                            </option>
                            <option value='222061'>
                              University of Virginia Health System TEST - Catheterization Lab
                            </option>
                            <option value='222060'>
                              University of Virginia Health System TEST - Endoscopy Outpatient
                              Center
                            </option>
                          </select>
                        </li>
                      </ul>
                    </div>
                    <div className='footer text-white bg-dark'>
                      <Icon.ExclamationTriangleFill /> Switching departments will redirect you back
                      to your starting page
                    </div>
                  </DropdownMenu>
                </UncontrolledDropdown>

                <div className='btn-search'>
                  <Icon.Search className='search-icon' />
                </div>
              </span>

              <Collapse className='qsight-nav-tabs' navbar>
                <ul className='navbar-nav'>
                  <NavItem className='parent open'>
                    <NavLink>
                      <span className='icon'>
                        <Icon.HouseDoor />
                      </span>
                      <span>Home</span>
                      <span className='expand d-block d-sm-none'>
                        <Icon.ChevronDown />
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink onClick={() => navigate('/')}>
                      <span className='icon'>
                        <Icon.Table />
                      </span>
                      <span>AutoPar</span>
                    </NavLink>
                  </NavItem>
                </ul>
                <div className='search d-none d-md-block'>
                  <input type='text' placeholder='Search...' name='q' />
                  <Icon.Search className='search-icon' />
                </div>
              </Collapse>
            </Navbar>
          </Container>
        </Navbar >
      </header >

      <Outlet />
    </>
  );
};

export default observer(QsightNavbar);
